import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserStateService } from '../services/user-state.service';

export const noAuthGuard: CanActivateFn = async () => {
  if (typeof window === 'undefined') {
    return true;
  }
  const userState = inject(UserStateService);
  await userState.waitForInitialization();

  if (userState.isAuthenticated) {
    userState.redirectAccordingly();
    return false;
  }

  return true;
};
